import Dropdown from './Dropdown';
import Button from './Button';
import classList from '../utils/classList';
import Tooltip from './Tooltip';
import Icon from './Icon';
/**
 * The `SplitDropdown` component is similar to `Dropdown`, but the first child
 * is displayed as its own button prior to the toggle button. Unless a custom
 * `mainAction` is provided as the main control.
 */
export default class SplitDropdown extends Dropdown {
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    attrs.className = classList(attrs.className, 'Dropdown--split', {
      'Dropdown--withMainAction': attrs.mainAction
    });
    attrs.menuClassName = classList(attrs.menuClassName, 'Dropdown-menu--right');
  }
  getButton(children) {
    // Make a copy of the attrs of the first child component. We will assign
    // these attrs to a new button, so that it has exactly the same behaviour as
    // the first child.
    const firstChild = this.attrs.mainAction || this.getFirstChild(children);
    const buttonAttrs = Object.assign({}, firstChild?.attrs);
    buttonAttrs.className = classList(buttonAttrs.className, 'SplitDropdown-button Button', this.attrs.buttonClassName);
    let button = m(Button, buttonAttrs, firstChild.children);
    if (this.attrs.tooltip) {
      button = m(Tooltip, {
        text: this.attrs.tooltip,
        position: "bottom"
      }, button);
    }
    return m('[', null, button, m("button", {
      className: 'Dropdown-toggle Button Button--icon ' + this.attrs.buttonClassName,
      "aria-haspopup": "menu",
      "aria-label": this.attrs.accessibleToggleLabel,
      "data-toggle": "dropdown"
    }, this.attrs.icon ? m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }) : null, m(Icon, {
      name: "fas fa-caret-down",
      className: "Button-caret"
    })));
  }

  /**
   * Get the first child. If the first child is an array, the first item in that
   * array will be returned.
   */
  getFirstChild(children) {
    let firstChild = children;
    while (firstChild instanceof Array) firstChild = firstChild[0];
    return firstChild;
  }
}
flarum.reg.add('core', 'common/components/SplitDropdown', SplitDropdown);